import { Injectable } from '@angular/core';
import { EssentialService } from './essential.service';

@Injectable({
  providedIn: 'root'
})
export class EskaMedicaDataSourceService {

  constructor(private essentialsService: EssentialService) {
  }

  invokeDataSource(dataSourceId, queryParamObj?, isFile?) {

    let url;

    if (isFile)
      url = `/ApiInvoker/InvokeWithFiles/${dataSourceId}`;
    else
      url = `/ApiInvoker/Invoke/${dataSourceId}`;

    let data = {
      inputType: []
    }
    if (queryParamObj) {
      if (queryParamObj.sourceId) {
        delete queryParamObj.sourceId
      }
      let keys = Object.keys(queryParamObj);
      keys.forEach(x => {
        Object.assign(data, { [x]: queryParamObj[x] });
        data.inputType.push(x);
      })
    }
    return this.essentialsService.postData(url, isFile ? queryParamObj : data);
  }
}
